import { Component, Input } from '@angular/core';

import { HeaderNavLink } from '../header/header';
import { faChevronDown, faChevronUp, faArrowRight, faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { QueryParamDirective } from '@core-mkt/services/query-param/query-param.directive';

@Component({
  selector: 'collapse-link',
  templateUrl: './collapse-link.component.html',
  standalone: true,
  imports: [FaIconComponent, QueryParamDirective],
})
export class CollapseLinkComponent {
  @Input() link: HeaderNavLink;
  collapsed = true;
  faCaretDown = faChevronDown;
  faCaretUp = faChevronUp;
  faArrowRight = faArrowRight;
  faCaretDownLegacy = faCaretDown;
  faCaretUpLegacy = faCaretUp;

  constructor() {}
}
